import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["calendlyDetails", "loader", "widget"];

  isCalendly() {
    const optionSelected = this.widgetTarget.selectedOptions[0].text;

    if(optionSelected == 'Calendly') {
      this.refreshCalendlyEvents();
    }
  }

  async refreshCalendlyEvents() {
    try {
      const indexUrl = `/calendly/event_types?integration_id=${this.calendlyDetailsTarget.dataset.integrationId}`;

      const response = await fetch(indexUrl);
      const data = await response.json();

      this.#updateEventsSelect(data);
    } catch (error) {
      console.error("Error refreshing Calendly events:", error);
    }
  }

  #updateEventsSelect(data){
    const fallbackEventsURL = this.calendlyDetailsTarget.dataset.defaultValue;
    const allEvents = Object.keys(data.all_events).length ? data.all_events : { "No events found": fallbackEventsURL };
    const selectElement = $(".calendly_events_select:last");

    selectElement.empty();

    $.each(allEvents, (key, value) => {
      selectElement.append($("<option>", {
        value: value,
        text: key,
      }));
    });
  }
}
